import { render, staticRenderFns } from "./UretimStokBirimCellRenderer.vue?vue&type=template&id=397f3aff"
import script from "./UretimStokBirimCellRenderer.vue?vue&type=script&lang=js"
export * from "./UretimStokBirimCellRenderer.vue?vue&type=script&lang=js"
import style0 from "./UretimStokBirimCellRenderer.vue?vue&type=style&index=0&id=397f3aff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports